import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, Copy, Check, ChevronRight, ChevronDown, ShieldCheck, CreditCard, ArrowRight, Info, HelpCircle, Landmark } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { FaBitcoin } from "react-icons/fa";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BITCOIN_ADDRESS = "bc1qqlu0uvyknuhx9x3ymf2dlmxyzapqwtkzlhsx7r";
const BANK_IBAN = "LT563130010112552948";
const BANK_BIC = "BZENLT22";

const BankIcon = ({ size = 18 }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="none">
    <rect width="32" height="32" rx="8" fill="#3B82F6"/>
    <path d="M16 7l8 5v2H8v-2l8-5z" fill="white"/>
    <rect x="10" y="15" width="2.5" height="7" rx="0.5" fill="white"/>
    <rect x="14.75" y="15" width="2.5" height="7" rx="0.5" fill="white"/>
    <rect x="19.5" y="15" width="2.5" height="7" rx="0.5" fill="white"/>
    <rect x="8" y="23" width="16" height="2" rx="0.5" fill="white"/>
  </svg>
);


const plans = [
  {
    id: "basico",
    amount: 50,
    label: "Basico",
    desc: "Acceso a Copy Trading",
    yield: "Rendimiento base",
    tag: null,
    url: "https://www.g2a.com/es/azteco-bitcoin-crypto-on-chain-voucher-50-eur-azteco-key-global-i10000337159006?___language=es&er=2f481717191c398f0288c284d914274e4a310aa16cc9c17cd46e38cecda7740d78c8f41fe4bfdd7831b0cae7a6e11a16&uuid=andres-martin-launch",
  },
  {
    id: "estandar",
    amount: 100,
    label: "Estandar",
    desc: "Mayor diversificacion",
    yield: "5x rentabilidad",
    tag: null,
    url: "https://www.g2a.com/es/azteco-bitcoin-crypto-on-chain-voucher-100-eur-azteco-key-global-i10000337159005",
  },
  {
    id: "premium",
    amount: 200,
    label: "Premium",
    desc: "Maximo potencial",
    yield: "15x rentabilidad",
    tag: "Popular",
    url: "https://www.g2a.com/es/azteco-bitcoin-crypto-on-chain-voucher-200-eur-azteco-key-global-i10000337159008",
  },
  {
    id: "vip",
    amount: 500,
    label: "VIP",
    desc: "Grupo VIP + Apalancamiento",
    yield: "50x rentabilidad",
    tag: "Mejor valor",
    url: "https://www.g2a.com/es/azteco-bitcoin-crypto-on-chain-voucher-500-eur-azteco-key-global-i10000337159004",
  },
];

export default function Deposit() {
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState("premium");
  const [voucherCode, setVoucherCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [copied, setCopied] = useState(false);
  const [tab, setTab] = useState("card");
  const [showGuide, setShowGuide] = useState(false);
  const [ibanCopied, setIbanCopied] = useState(false);
  const [bicCopied, setBicCopied] = useState(false);

  const activePlan = plans.find((p) => p.id === selectedPlan) || plans[2];

  const handleBuy = (plan) => {
    setSelectedPlan(plan.id);
    window.open(plan.url, "_blank");
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(BITCOIN_ADDRESS);
    setCopied(true);
    toast.success("Direccion copiada");
    setTimeout(() => setCopied(false), 2000);
  };

  const handleRedeem = async () => {
    if (!voucherCode.trim()) {
      toast.error("Introduce el enlace de tu voucher");
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${API}/transactions/deposit`,
        { type: "deposit", amount: activePlan.amount, method: `CryptoVoucher: ${voucherCode.trim()}` },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccess(true);
      toast.success("Voucher enviado correctamente");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error al procesar");
    } finally {
      setLoading(false);
    }
  };

  const handleBtcDeposit = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${API}/transactions/deposit`,
        { type: "deposit", amount: activePlan.amount, method: `Bitcoin: ${BITCOIN_ADDRESS}` },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccess(true);
      toast.success("Deposito registrado");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error al procesar");
    } finally {
      setLoading(false);
    }
  };

  const handleCopyIban = () => {
    navigator.clipboard.writeText(BANK_IBAN);
    setIbanCopied(true);
    toast.success("IBAN copiado");
    setTimeout(() => setIbanCopied(false), 2000);
  };

  const handleCopyBic = () => {
    navigator.clipboard.writeText(BANK_BIC);
    setBicCopied(true);
    toast.success("BIC/SWIFT copiado");
    setTimeout(() => setBicCopied(false), 2000);
  };

  const handleBankTransfer = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${API}/transactions/deposit`,
        { type: "deposit", amount: activePlan.amount, method: `Transferencia bancaria (IBAN: ${BANK_IBAN})` },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccess(true);
      toast.success("Deposito registrado. Pendiente de confirmacion.");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error al procesar");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="max-w-md mx-auto mt-12" data-testid="deposit-success">
        <div className="bg-[#181A20] rounded-xl border border-[#2B3139] p-8 text-center">
          <div className="w-14 h-14 rounded-full bg-[#0ECB81]/10 flex items-center justify-center mx-auto mb-5">
            <CheckCircle2 className="w-7 h-7 text-[#0ECB81]" />
          </div>
          <h2 className="text-xl font-semibold text-[#EAECEF] mb-2">Solicitud recibida</h2>
          <p className="text-sm text-[#848E9C] mb-6 leading-relaxed">
            Tu deposito esta siendo verificado. Recibiras una notificacion cuando los fondos esten disponibles.
          </p>
          <div className="bg-[#0B0E11] rounded-lg p-4 mb-6 border border-[#2B3139]">
            <div className="flex justify-between text-sm mb-2">
              <span className="text-[#848E9C]">Importe</span>
              <span className="text-[#EAECEF] font-medium">{activePlan.amount.toLocaleString("es-ES")} EUR</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-[#848E9C]">Estado</span>
              <span className="text-[#FCD535] font-medium">Pendiente de verificacion</span>
            </div>
          </div>
          <button
            onClick={() => navigate("/portfolio")}
            className="w-full h-11 rounded-lg bg-[#FCD535] text-[#0B0E11] text-sm font-semibold hover:bg-[#e5c230] transition-colors"
            data-testid="goto-portfolio"
          >
            Ir al Portafolio
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-[960px] mx-auto" data-testid="deposit-page">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-[22px] font-semibold text-[#EAECEF] tracking-[-0.02em]">Depositar</h1>
        <p className="text-sm text-[#848E9C] mt-1">Selecciona un plan e ingresa fondos a tu cuenta</p>
      </div>

      {/* Plans */}
      <div className="mb-8">
        <div className="text-xs font-medium text-[#848E9C] uppercase tracking-wider mb-3">Plan de inversion</div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          {plans.map((plan) => {
            const active = selectedPlan === plan.id;
            return (
              <button
                key={plan.id}
                type="button"
                onClick={() => setSelectedPlan(plan.id)}
                className={`relative text-left rounded-xl border p-4 transition-all duration-150 ${
                  active
                    ? "border-[#FCD535] bg-[#FCD535]/[0.04]"
                    : "border-[#2B3139] bg-[#181A20] hover:border-[#3B4149] hover:bg-[#1E2329]"
                }`}
                data-testid={`plan-${plan.id}`}
              >
                {plan.tag && (
                  <span
                    className={`absolute -top-2.5 right-3 text-[10px] font-semibold px-2 py-0.5 rounded ${
                      plan.id === "vip"
                        ? "bg-[#FFD700]/15 text-[#FFD700] border border-[#FFD700]/20"
                        : "bg-[#0ECB81]/15 text-[#0ECB81] border border-[#0ECB81]/20"
                    }`}
                  >
                    {plan.tag}
                  </span>
                )}

                <div className="flex items-baseline gap-1 mb-1.5">
                  <span className={`text-2xl font-semibold tabular-nums tracking-tight ${active ? "text-[#EAECEF]" : "text-[#EAECEF]"}`}>
                    {plan.amount}
                  </span>
                  <span className="text-xs text-[#848E9C] font-medium">EUR</span>
                </div>

                <p className={`text-xs font-medium mb-0.5 ${active ? "text-[#FCD535]" : "text-[#848E9C]"}`}>
                  {plan.label}
                </p>
                <p className="text-[11px] text-[#474D57] leading-snug">{plan.desc}</p>

                <div className={`mt-3 pt-3 border-t ${active ? "border-[#FCD535]/20" : "border-[#2B3139]"}`}>
                  <span className={`text-[11px] font-semibold ${
                    plan.id === "vip" ? "text-[#FFD700]" : plan.id === "premium" ? "text-[#0ECB81]" : active ? "text-[#FCD535]" : "text-[#848E9C]"
                  }`}>
                    {plan.yield}
                  </span>
                </div>

                {/* Active indicator */}
                {active && (
                  <div className="absolute top-3 right-3">
                    <div className="w-4 h-4 rounded-full bg-[#FCD535] flex items-center justify-center">
                      <Check className="w-2.5 h-2.5 text-[#0B0E11]" strokeWidth={3} />
                    </div>
                  </div>
                )}
              </button>
            );
          })}
        </div>

        {/* Buy button for selected plan */}
        <button
          onClick={() => handleBuy(activePlan)}
          className="mt-4 w-full lg:w-auto inline-flex items-center justify-center gap-2 h-10 px-6 rounded-lg bg-[#FCD535] text-[#0B0E11] text-sm font-semibold hover:bg-[#e5c230] transition-colors"
          data-testid={`select-plan-${activePlan.id}`}
        >
          Comprar voucher de {activePlan.amount} EUR
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>

      {/* Divider */}
      <div className="border-t border-[#2B3139] mb-8" />

      {/* Deposit Section */}
      <div className="grid lg:grid-cols-[1fr_340px] gap-6">
        {/* Left - Tabs + Forms */}
        <div>
          {/* Tabs */}
          <div className="flex border-b border-[#2B3139] mb-6">
            <button
              onClick={() => setTab("card")}
              className={`flex items-center gap-2 px-4 pb-3 text-sm font-medium border-b-2 transition-colors -mb-[1px] ${
                tab === "card"
                  ? "border-[#FCD535] text-[#EAECEF]"
                  : "border-transparent text-[#848E9C] hover:text-[#EAECEF]"
              }`}
              data-testid="method-voucher"
            >
              <CreditCard className="w-4 h-4" />
              Tarjeta / Voucher
            </button>
            <button
              onClick={() => setTab("btc")}
              className={`flex items-center gap-2 px-4 pb-3 text-sm font-medium border-b-2 transition-colors -mb-[1px] ${
                tab === "btc"
                  ? "border-[#F7931A] text-[#EAECEF]"
                  : "border-transparent text-[#848E9C] hover:text-[#EAECEF]"
              }`}
              data-testid="method-bitcoin"
            >
              <FaBitcoin className="w-4 h-4" />
              Bitcoin
            </button>
            <button
              onClick={() => setTab("bank")}
              className={`relative flex items-center gap-2 px-4 pb-3 text-sm font-medium border-b-2 transition-colors -mb-[1px] ${
                tab === "bank"
                  ? "border-[#3B82F6] text-[#EAECEF]"
                  : "border-transparent text-[#848E9C] hover:text-[#EAECEF]"
              }`}
              data-testid="method-bank"
            >
              <BankIcon size={18} />
              Transferencia
              <span className="text-[9px] font-bold tracking-wider uppercase px-1.5 py-0.5 rounded bg-[#0ECB81] text-[#0B0E11] leading-none">Nuevo</span>
            </button>
          </div>

          {/* Voucher Form */}
          {tab === "card" && (
            <div data-testid="voucher-section">
              <div className="mb-5">
                <h3 className="text-base font-semibold text-[#EAECEF] mb-1">Canjear voucher</h3>
                <p className="text-xs text-[#848E9C] leading-relaxed">
                  Pega el enlace que has recibido tras la compra del voucher. El importe se depositara automaticamente.
                </p>
              </div>

              <div className="space-y-3">
                <div>
                  <label className="text-xs text-[#848E9C] font-medium mb-1.5 block">Enlace del voucher</label>
                  <input
                    type="text"
                    placeholder="https://afrfrte.com/claim/..."
                    value={voucherCode}
                    onChange={(e) => setVoucherCode(e.target.value)}
                    className="w-full h-11 px-3 rounded-lg bg-[#0B0E11] border border-[#2B3139] text-[#EAECEF] text-sm font-mono placeholder-[#474D57] focus:border-[#FCD535] focus:outline-none focus:ring-1 focus:ring-[#FCD535]/30 transition-all"
                    data-testid="voucher-code"
                  />
                </div>

                <div>
                  <label className="text-xs text-[#848E9C] font-medium mb-1.5 block">Importe del plan</label>
                  <div className="h-11 px-3 rounded-lg bg-[#0B0E11] border border-[#2B3139] flex items-center">
                    <span className="text-sm text-[#EAECEF] font-medium tabular-nums">{activePlan.amount}.00</span>
                    <span className="text-xs text-[#848E9C] ml-1.5">EUR</span>
                    <span className="ml-auto text-[10px] text-[#474D57] bg-[#2B3139] px-2 py-0.5 rounded">{activePlan.label}</span>
                  </div>
                </div>

                <button
                  onClick={handleRedeem}
                  disabled={loading}
                  className="w-full h-11 rounded-lg bg-[#FCD535] text-[#0B0E11] text-sm font-semibold hover:bg-[#e5c230] disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2"
                  data-testid="apply-voucher-btn"
                >
                  {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Canjear <ArrowRight className="w-3.5 h-3.5" /></>}
                </button>
              </div>

              {/* Guide: How to find your voucher link */}
              <div className="mt-5 rounded-lg border border-[#2B3139] overflow-hidden" data-testid="voucher-guide">
                <button
                  onClick={() => setShowGuide(!showGuide)}
                  className="w-full flex items-center justify-between px-4 py-3 bg-[#181A20] hover:bg-[#1E2329] transition-colors text-left"
                  data-testid="voucher-guide-toggle"
                >
                  <div className="flex items-center gap-2.5">
                    <HelpCircle className="w-4 h-4 text-[#FCD535]" />
                    <span className="text-sm font-medium text-[#EAECEF]">No encuentras tu enlace del voucher?</span>
                  </div>
                  <ChevronDown className={`w-4 h-4 text-[#848E9C] transition-transform duration-200 ${showGuide ? "rotate-180" : ""}`} />
                </button>

                {showGuide && (
                  <div className="px-4 pb-4 pt-1 bg-[#0B0E11] border-t border-[#2B3139]">
                    <p className="text-xs text-[#848E9C] mb-4">
                      Tras comprar tu voucher Azteco en G2A, sigue estos pasos para encontrar el enlace que debes pegar aqui:
                    </p>

                    <div className="space-y-4">
                      {/* Step 1 */}
                      <div className="flex gap-3">
                        <div className="flex-shrink-0 w-7 h-7 rounded-full bg-[#FCD535]/10 flex items-center justify-center">
                          <span className="text-xs font-bold text-[#FCD535]">1</span>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-[#EAECEF] mb-0.5">Revisa tu correo electronico</p>
                          <p className="text-xs text-[#848E9C] leading-relaxed">
                            Tras completar la compra en G2A, recibiras un email de confirmacion en la direccion asociada a tu cuenta de G2A.
                          </p>
                        </div>
                      </div>

                      {/* Step 2 */}
                      <div className="flex gap-3">
                        <div className="flex-shrink-0 w-7 h-7 rounded-full bg-[#FCD535]/10 flex items-center justify-center">
                          <span className="text-xs font-bold text-[#FCD535]">2</span>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-[#EAECEF] mb-0.5">Abre el email de G2A</p>
                          <p className="text-xs text-[#848E9C] leading-relaxed">
                            Busca el email con el asunto de tu compra. Si no lo ves en la bandeja principal, revisa la carpeta de <span className="text-[#EAECEF] font-medium">Spam</span> o <span className="text-[#EAECEF] font-medium">Promociones</span>.
                          </p>
                        </div>
                      </div>

                      {/* Step 3 */}
                      <div className="flex gap-3">
                        <div className="flex-shrink-0 w-7 h-7 rounded-full bg-[#FCD535]/10 flex items-center justify-center">
                          <span className="text-xs font-bold text-[#FCD535]">3</span>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-[#EAECEF] mb-0.5">Pulsa en "Ver producto" o "Mostrar clave"</p>
                          <p className="text-xs text-[#848E9C] leading-relaxed">
                            Dentro del email veras un boton que dice <span className="text-[#FCD535] font-medium">"Ver producto"</span>, <span className="text-[#FCD535] font-medium">"Ver clave"</span> o similar. Haz clic en el.
                          </p>
                        </div>
                      </div>

                      {/* Step 4 */}
                      <div className="flex gap-3">
                        <div className="flex-shrink-0 w-7 h-7 rounded-full bg-[#FCD535]/10 flex items-center justify-center">
                          <span className="text-xs font-bold text-[#FCD535]">4</span>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-[#EAECEF] mb-0.5">Copia el enlace del voucher</p>
                          <p className="text-xs text-[#848E9C] leading-relaxed">
                            Se abrira una pagina con tu enlace Azteco (empieza por <span className="font-mono text-[#FCD535]">https://azte.co/...</span> o similar). <span className="text-[#EAECEF] font-medium">Copia ese enlace completo</span>.
                          </p>
                        </div>
                      </div>

                      {/* Step 5 */}
                      <div className="flex gap-3">
                        <div className="flex-shrink-0 w-7 h-7 rounded-full bg-[#0ECB81]/10 flex items-center justify-center">
                          <Check className="w-3.5 h-3.5 text-[#0ECB81]" />
                        </div>
                        <div>
                          <p className="text-sm font-medium text-[#EAECEF] mb-0.5">Pegalo aqui arriba y pulsa Canjear</p>
                          <p className="text-xs text-[#848E9C] leading-relaxed">
                            Pega el enlace en el campo <span className="text-[#EAECEF] font-medium">"Enlace del voucher"</span> de esta pagina y pulsa <span className="text-[#FCD535] font-medium">Canjear</span>. Nuestro equipo lo verificara y acreditara el saldo en tu cuenta.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Tip box */}
                    <div className="mt-4 flex items-start gap-2.5 p-3 rounded-lg bg-[#FCD535]/[0.05] border border-[#FCD535]/10">
                      <Info className="w-3.5 h-3.5 text-[#FCD535] flex-shrink-0 mt-0.5" />
                      <p className="text-[11px] text-[#848E9C] leading-relaxed">
                        <span className="text-[#EAECEF] font-medium">Consejo:</span> Tambien puedes acceder a tus compras desde tu cuenta de G2A en la seccion <span className="text-[#FCD535]">Mis compras</span> &gt; selecciona el producto &gt; <span className="text-[#FCD535]">Ver clave</span>.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Bitcoin Form */}
          {tab === "btc" && (
            <div data-testid="btc-section">
              <div className="mb-5">
                <h3 className="text-base font-semibold text-[#EAECEF] mb-1">Deposito directo en Bitcoin</h3>
                <p className="text-xs text-[#848E9C] leading-relaxed">
                  Envia el equivalente en BTC a la direccion indicada. Se acreditara tras 3 confirmaciones en la red.
                </p>
              </div>

              {/* Network badge */}
              <div className="flex items-center gap-2 mb-4 text-xs">
                <span className="text-[#848E9C]">Red:</span>
                <span className="bg-[#F7931A]/10 text-[#F7931A] px-2 py-0.5 rounded font-medium border border-[#F7931A]/20">Bitcoin (BTC)</span>
                <span className="text-[#848E9C]">&middot;</span>
                <span className="text-[#EAECEF] font-medium tabular-nums">{activePlan.amount} EUR</span>
              </div>

              {/* Address */}
              <div className="mb-4">
                <label className="text-xs text-[#848E9C] font-medium mb-1.5 block">Direccion BTC</label>
                <div className="flex gap-2">
                  <div className="flex-1 h-11 px-3 rounded-lg bg-[#0B0E11] border border-[#2B3139] flex items-center overflow-hidden">
                    <span className="text-xs font-mono text-[#F7931A] truncate" data-testid="bitcoin-address">{BITCOIN_ADDRESS}</span>
                  </div>
                  <button
                    onClick={handleCopy}
                    className="h-11 w-11 flex-shrink-0 rounded-lg border border-[#2B3139] bg-[#181A20] hover:bg-[#1E2329] flex items-center justify-center text-[#848E9C] hover:text-[#EAECEF] transition-colors"
                    data-testid="copy-btc-address"
                  >
                    {copied ? <Check className="w-4 h-4 text-[#0ECB81]" /> : <Copy className="w-4 h-4" />}
                  </button>
                </div>
              </div>

              {/* Warning */}
              <div className="flex items-start gap-2.5 p-3 rounded-lg bg-[#F7931A]/[0.05] border border-[#F7931A]/10 mb-4">
                <Info className="w-3.5 h-3.5 text-[#F7931A] flex-shrink-0 mt-0.5" />
                <p className="text-[11px] text-[#848E9C] leading-relaxed">
                  Envia <span className="text-[#EAECEF] font-medium">unicamente Bitcoin (BTC)</span> a esta direccion. Enviar otra criptomoneda puede resultar en la perdida permanente de fondos.
                </p>
              </div>

              <button
                onClick={handleBtcDeposit}
                disabled={loading}
                className="w-full h-11 rounded-lg bg-[#F7931A] text-white text-sm font-semibold hover:bg-[#e58317] disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2"
                data-testid="submit-btc-deposit"
              >
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Confirmar deposito <ArrowRight className="w-3.5 h-3.5" /></>}
              </button>
            </div>
          )}

          {/* Bank Transfer Form */}
          {tab === "bank" && (
            <div data-testid="bank-section">
              {/* Bank Transfer Header */}
              <div className="rounded-xl border border-[#3B82F6]/20 bg-gradient-to-b from-[#3B82F6]/[0.06] to-transparent p-5 mb-5">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2.5">
                    <BankIcon size={22} />
                    <span className="text-base font-semibold text-[#EAECEF]">Transferencia Instantanea</span>
                  </div>
                  <span className="text-[10px] font-bold tracking-wider uppercase px-2 py-1 rounded-md bg-[#0ECB81]/15 text-[#0ECB81] border border-[#0ECB81]/20">Nuevo</span>
                </div>
                <p className="text-sm text-[#EAECEF] font-medium mb-1">Tu IBAN personal para depositos inmediatos</p>
                <p className="text-xs text-[#848E9C] leading-relaxed">
                  Este es tu IBAN exclusivo asignado a tu cuenta. Transfiere el importe de tu plan y se acreditara al instante en tu portafolio. Puedes usarlo siempre que quieras anadir fondos.
                </p>
              </div>

              {/* Instant badge */}
              <div className="flex items-center gap-2 mb-4 px-3 py-2 bg-[#0ECB81]/[0.06] rounded-lg border border-[#0ECB81]/15">
                <div className="w-2 h-2 rounded-full bg-[#0ECB81] animate-pulse" />
                <span className="text-xs text-[#0ECB81] font-medium">Acreditacion instantanea</span>
                <span className="text-[10px] text-[#848E9C]">&mdash; El saldo se refleja al momento en tu portafolio</span>
              </div>

              {/* IBAN */}
              <div className="space-y-3">
                <div>
                  <label className="text-xs text-[#848E9C] font-medium mb-1.5 block">Tu IBAN personal</label>
                  <div className="flex gap-2">
                    <div className="flex-1 h-12 px-4 rounded-lg bg-[#0B0E11] border border-[#2B3139] flex items-center">
                      <span className="text-sm font-mono text-[#3B82F6] tracking-wider font-medium" data-testid="bank-iban">
                        {BANK_IBAN.replace(/(.{4})/g, '$1 ').trim()}
                      </span>
                    </div>
                    <button
                      onClick={handleCopyIban}
                      className="h-12 w-12 flex-shrink-0 rounded-lg border border-[#2B3139] bg-[#181A20] hover:bg-[#1E2329] flex items-center justify-center text-[#848E9C] hover:text-[#EAECEF] transition-colors"
                      data-testid="copy-iban"
                    >
                      {ibanCopied ? <Check className="w-4 h-4 text-[#0ECB81]" /> : <Copy className="w-4 h-4" />}
                    </button>
                  </div>
                </div>

                {/* BIC/SWIFT */}
                <div>
                  <label className="text-xs text-[#848E9C] font-medium mb-1.5 block">BIC / SWIFT</label>
                  <div className="flex gap-2">
                    <div className="flex-1 h-12 px-4 rounded-lg bg-[#0B0E11] border border-[#2B3139] flex items-center">
                      <span className="text-sm font-mono text-[#3B82F6] tracking-wider font-medium" data-testid="bank-bic">
                        {BANK_BIC}
                      </span>
                    </div>
                    <button
                      onClick={handleCopyBic}
                      className="h-12 w-12 flex-shrink-0 rounded-lg border border-[#2B3139] bg-[#181A20] hover:bg-[#1E2329] flex items-center justify-center text-[#848E9C] hover:text-[#EAECEF] transition-colors"
                      data-testid="copy-bic"
                    >
                      {bicCopied ? <Check className="w-4 h-4 text-[#0ECB81]" /> : <Copy className="w-4 h-4" />}
                    </button>
                  </div>
                </div>

                {/* Amount */}
                <div>
                  <label className="text-xs text-[#848E9C] font-medium mb-1.5 block">Importe a transferir</label>
                  <div className="h-12 px-4 rounded-lg bg-[#0B0E11] border border-[#2B3139] flex items-center">
                    <span className="text-sm text-[#EAECEF] font-semibold tabular-nums">{activePlan.amount}.00</span>
                    <span className="text-xs text-[#848E9C] ml-1.5">EUR</span>
                    <span className="ml-auto text-[10px] text-[#474D57] bg-[#2B3139] px-2 py-0.5 rounded">{activePlan.label}</span>
                  </div>
                </div>

                {/* Instructions */}
                <div className="bg-[#0B0E11] rounded-lg border border-[#2B3139] p-4 space-y-2.5">
                  <p className="text-xs font-medium text-[#EAECEF] mb-2">Como funciona:</p>
                  <div className="flex items-start gap-2.5">
                    <div className="w-5 h-5 rounded-full bg-[#3B82F6]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="text-[9px] font-bold text-[#3B82F6]">1</span>
                    </div>
                    <p className="text-xs text-[#848E9C] leading-relaxed">
                      Copia tu <span className="text-[#EAECEF] font-medium">IBAN personal</span> y el <span className="text-[#EAECEF] font-medium">BIC/SWIFT</span>
                    </p>
                  </div>
                  <div className="flex items-start gap-2.5">
                    <div className="w-5 h-5 rounded-full bg-[#3B82F6]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="text-[9px] font-bold text-[#3B82F6]">2</span>
                    </div>
                    <p className="text-xs text-[#848E9C] leading-relaxed">
                      Realiza una transferencia de <span className="text-[#EAECEF] font-semibold tabular-nums">{activePlan.amount}.00 EUR</span> desde la app de tu banco
                    </p>
                  </div>
                  <div className="flex items-start gap-2.5">
                    <div className="w-5 h-5 rounded-full bg-[#0ECB81]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Check className="w-2.5 h-2.5 text-[#0ECB81]" />
                    </div>
                    <p className="text-xs text-[#848E9C] leading-relaxed">
                      Los fondos se <span className="text-[#0ECB81] font-medium">acreditan al instante</span> en tu portafolio y podras empezar a operar
                    </p>
                  </div>
                </div>

                {/* Security note */}
                <div className="flex items-start gap-2.5 p-3 rounded-lg bg-[#3B82F6]/[0.04] border border-[#3B82F6]/10">
                  <ShieldCheck className="w-3.5 h-3.5 text-[#3B82F6] flex-shrink-0 mt-0.5" />
                  <p className="text-[11px] text-[#848E9C] leading-relaxed">
                    Tu IBAN es <span className="text-[#EAECEF] font-medium">unico y personal</span>. Puedes guardar estos datos para futuras transferencias y anadir fondos siempre que quieras.
                  </p>
                </div>

                {/* CTA Button */}
                <button
                  onClick={handleBankTransfer}
                  disabled={loading}
                  className="w-full h-12 rounded-lg text-sm font-bold disabled:opacity-40 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2.5 text-white"
                  style={{ background: "linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)", boxShadow: "0 4px 14px rgba(59,130,246,0.3)" }}
                  data-testid="submit-bank-transfer"
                >
                  {loading ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    <>
                      <Landmark className="w-4 h-4" />
                      He realizado la transferencia
                      <ArrowRight className="w-3.5 h-3.5" />
                    </>
                  )}
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Right - Info Sidebar */}
        <div className="space-y-4">
          {/* Order summary */}
          <div className="bg-[#181A20] rounded-xl border border-[#2B3139] p-5">
            <div className="text-xs font-medium text-[#848E9C] uppercase tracking-wider mb-4">Resumen</div>
            <div className="space-y-3">
              <div className="flex justify-between text-sm">
                <span className="text-[#848E9C]">Plan</span>
                <span className="text-[#EAECEF] font-medium">{activePlan.label}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-[#848E9C]">Importe</span>
                <span className="text-[#EAECEF] font-semibold tabular-nums">{activePlan.amount}.00 EUR</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-[#848E9C]">Rendimiento</span>
                <span className={`font-medium ${
                  activePlan.id === "vip" ? "text-[#FFD700]" : activePlan.id === "premium" ? "text-[#0ECB81]" : "text-[#FCD535]"
                }`}>{activePlan.yield}</span>
              </div>
              <div className="border-t border-[#2B3139] pt-3 flex justify-between text-sm">
                <span className="text-[#848E9C]">Metodo</span>
                <span className="text-[#EAECEF] font-medium">{tab === "card" ? "Tarjeta / Voucher" : tab === "btc" ? "Bitcoin" : "Transferencia"}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-[#848E9C]">Comision</span>
                <span className="text-[#0ECB81] font-medium">0.00 EUR</span>
              </div>
            </div>
          </div>

          {/* How it works */}
          <div className="bg-[#181A20] rounded-xl border border-[#2B3139] p-5">
            <div className="text-xs font-medium text-[#848E9C] uppercase tracking-wider mb-4">Como funciona</div>
            <div className="space-y-4">
              {[
                { step: "1", text: "Selecciona tu plan y compra el voucher" },
                { step: "2", text: "Pega el enlace en el formulario" },
                { step: "3", text: "El equipo verifica y acredita el deposito" },
              ].map((s) => (
                <div key={s.step} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-[#FCD535]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-[11px] font-bold text-[#FCD535]">{s.step}</span>
                  </div>
                  <p className="text-xs text-[#848E9C] leading-relaxed">{s.text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Security */}
          <div className="flex items-center gap-2 px-4 py-3 rounded-lg border border-[#2B3139] bg-[#181A20]">
            <ShieldCheck className="w-4 h-4 text-[#0ECB81]" />
            <span className="text-[11px] text-[#848E9C]">Transacciones encriptadas y protegidas por SSL</span>
          </div>
        </div>
      </div>
    </div>
  );
}
